// The system and customer report editors used to live under a `-beta` twin of their route while
// the old editor held the plain one. The old editor is gone and the plain route is the editor
// now, so a `-beta` address is only ever a bookmark or a link from before - it still has to
// land somewhere. Only these two lose their twin; `reports-beta` is a separate question.
//
// Case-insensitive because React Router matches routes that way: a mixed-case bookmark mounts the
// redirect too, and a rewrite that missed it would send the user to the address they are already
// on. The segment is written back in the route's own lowercase.
const RETIRED_BETA_SEGMENT = /\/(systemreportselections|customerreports)-beta(?=\/|$)/i

export const withoutBetaSegment = (pathname) =>
  pathname.replace(
    RETIRED_BETA_SEGMENT,
    (segment, route) => `/${route.toLowerCase()}`
  )
